// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Conect_wrapper__FXbDc","text":"Conect_text__Usyhu"};